module.exports = __webpack_public_path__ + "media/site/images/products/saas_actionplan-screen1-e3a7eff884346ea9301bdae86a23f9bd.png";